export const canGoBack = () => {
  return window.history.length > 1;
};
